import React from 'react';

import { usePortfolio } from '../../contexts/PortfolioContext';
import type { SampleAsset } from '../../types/financial';
import { PortfolioAccountsCard } from '../wealth/PortfolioAccountsCard';

type PortfolioSnapshotProps = {
  /** Fallback when Mongo portfolio is empty (sample / offline). */
  assets?: SampleAsset[];
  onPress?: () => void;
  actionLabel?: string;
};

/** Home portfolio widget — import, manual add, edit/delete when synced. */
export function PortfolioSnapshot({
  assets = [],
  onPress,
  actionLabel = 'Wealth',
}: PortfolioSnapshotProps) {
  const { latest } = usePortfolio();

  const fallbackRows =
    latest == null
      ? assets
          .filter((a) => a.isInvestment)
          .map((a) => ({
            id: a.id,
            label: a.label,
            value: a.value,
            expectedReturnPct: a.expectedReturnPct,
          }))
      : [];

  return (
    <PortfolioAccountsCard
      title="Portfolio"
      category="investment"
      compact
      fallbackRows={fallbackRows}
      headerAction={
        onPress ? { label: actionLabel, onPress } : undefined
      }
    />
  );
}
